import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=5c0ed804&scoped=true"
import script from "./deviceDetails.vue?vue&type=script&lang=js"
export * from "./deviceDetails.vue?vue&type=script&lang=js"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&id=5c0ed804&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ed804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0ed804')) {
      api.createRecord('5c0ed804', component.options)
    } else {
      api.reload('5c0ed804', component.options)
    }
    module.hot.accept("./deviceDetails.vue?vue&type=template&id=5c0ed804&scoped=true", function () {
      api.rerender('5c0ed804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/device-log/deviceDetails.vue"
export default component.exports